import {Observable} from 'rxjs';
import {PaginatedResult} from '../models/paginated-result.model';
import {Pagination} from '../models/pagination.model';

export abstract class IPaginatedService<T> {
  abstract call(pagination?: Pagination, queryParams?: any): Observable<PaginatedResult<T>>;
}
